import { useEffect, useRef, useState } from "react";
import { VolunteerInfo, VolunteerForm, VolunteerCards, VolunteerCollage, Banner, InfoSection } from "../components";
import { tracking } from '../utils/tracking';
import { useResizeImg } from '../hooks/useResizeImg';
import { imgs } from "../assets/imgs";
import { updateTags } from "../utils/funcs";

export const Volunteer = () => {
   const [isLoading, setIsLoading] = useState(true);
   const scrollRef = useRef(null);
   const imageSource = useResizeImg(imgs.volunteer.volunteerBannerDesktop, imgs.volunteer.volunteerBannerMobile);

   useEffect(() => {
      updateTags("Venture Summit West | Volunteer")
   }, [])

   return (
      <div className="volunteer">
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1>Volunteer</h1>
               <h2>Make Connections that last a lifetime</h2>
            </section>
            <section>
               <button className="btn" onClick={() => { tracking(335); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }}>APPLY NOW</button>
            </section>
         </Banner>
         <InfoSection img={imgs.volunteer.volunteerInfo}>
            <h1>Your Future Awaits.</h1>
            <p>Our unique Volunteer Program offers students and aspiring professionals a gateway to meet, learn from, and rub elbows with top founders and investors. Whether you have a passion for entrepreneurship or have a dream to join a venture firm, this opportunity is for you!</p>
            <h1>Unlimited Opportunities.</h1>
            <h3>Limited Slots</h3>
            <p>Apply to become a volunteer and join the team behind the Venture Summit.</p>
            {/* <div className='btn-container'>
               <button className='btn' onClick={() => { tracking(336); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }} >
                  Apply now
               </button>
            </div> */}
         </InfoSection>
         <VolunteerCards />
         <VolunteerCollage scrollRef={scrollRef} />
         <VolunteerForm />
      </div>
   )
}